import React from 'react'
import {
  makeStyles,
  createStyles,
  Box,
  List,
  ListItem,
  ListItemText,
  Divider,
  Typography,
  Link,
} from '@material-ui/core/'
import { ReactComponent as PhoneContactIcon } from 'src/mobile/assets/icons/phone-contact.svg'
import { ReactComponent as MailIcon } from 'src/mobile/assets/icons/mail.svg'
import { ReactComponent as WhatsAppIcon } from 'src/mobile/assets/icons/whats-app.svg'
import { SERVICE_PHONE, SERVICE_EMAIL, SERVICE_WHATSAPP, SITE_MATE_DATA } from 'src/utils/constant'
import { useTranslation } from 'react-i18next'

const useStyles = makeStyles((theme) =>
  createStyles({
    listItem: {
      padding: theme.spacing(2, 0),
    },
    avatar: {
      marginRight: theme.spacing(2),
    },
  }),
)

const Contact = () => {
  const classes = useStyles()
  const { t, i18n } = useTranslation()
  const CONTACT_LIST = [
    {
      title: 'common.contact_phone',
      subtitle: SERVICE_PHONE,
      href: `tel:${SERVICE_PHONE}`,
      icon: <PhoneContactIcon />,
    },
    {
      title: 'WhatsApp',
      subtitle: SERVICE_WHATSAPP,
      href:
        i18n.language === 'zh-HK'
          ? SITE_MATE_DATA.WHATSAPP_PC_HK
          : i18n.language === 'en'
          ? SITE_MATE_DATA.WHATSAPP_PC_EN
          : SITE_MATE_DATA.WHATSAPP_PC_CN,
      icon: <WhatsAppIcon />,
    },
    {
      title: 'form.email',
      subtitle: SERVICE_EMAIL,
      href: `mailto:${SERVICE_EMAIL}`,
      icon: <MailIcon />,
    },
  ]
  return (
    <Box bgcolor="background.paper" px={3} pt={2} mt="1px">
      <List disablePadding>
        {CONTACT_LIST.map((contact) => (
          <React.Fragment key={contact.title}>
            <ListItem className={classes.listItem} underline="none" href={contact.href} component={Link}>
              <Box className={classes.avatar}>{contact.icon}</Box>
              <ListItemText
                primary={
                  <Typography variant="h5">
                    <Box color="grey.900" component="span">
                      {t(contact.title)}
                    </Box>
                  </Typography>
                }
                secondary={
                  <Typography variant="h4" color="secondary">
                    <Box fontWeight="fontWeightMedium" component="span">
                      {contact.subtitle}
                    </Box>
                  </Typography>
                }
              />
            </ListItem>
            <Divider />
          </React.Fragment>
        ))}
      </List>
    </Box>
  )
}

export default Contact
